import { IOption } from "../components/selects/select"

export enum TypeExport {
    xlsx = "xlsx",
    xml = "xml",
}

export enum GridRowHeightEnum {
    normal = 36,
    sparse = 44,
    compressed = 30,
}

export enum LoadingStatus {
    NoData,
    InProcess,
    Completed,
    Failed,
    NoAccess,
    None,
    Exporting,
}

export enum DocumentStateType {
    new = "new",
    draft = "draft",
    cancel = "cancel",
    proc = "proc",
    del = "del",
    done = "done",
    sent = "sent",
    deposited = "deposited",
    internetOrder = "internetOrder",
    open = "Open",
    closed = "Closed",
    mdlp = "mdlp",
    secured = "secured",
    internet_order = "internet_order",
}

export enum DocumentStatusType {
    New = "new",
    Draft = "draft",
    Del = "del",
    Cancel = "cancel",
    Save = "save",
    Prov = "proc",
    Done = "done",
    Sent = "sent",
    Secured = "secured"
}

export enum KizStateType {
    save = "Save",
    hold = "Hold",
    proc = "Proc",
    part = "Part",
    exit = "Exit",
    stop = "Stop",
    del = "Del",
}

export enum EncodingType {
    Auto = 'Auto',
    UTF8 = 'UTF-8',
    ASCII = 'US-ASCII',
    windows = 'windows-1251',
    UTF16 = 'UTF-16',
    cp866 = 'cp866',
    base64 = 'base64',
    ascii = 'ascii',
}

export enum DocumentType {
    cheque = "Cheque",
    invoice = "Invoice",
    invoiceOut = "InvoiceOut",
    movement = "Movement",
    revaluation = "Revaluation",
    disassembling = "Disassembling",
    disaggregation = "Disaggregation",
    importRemains = "ImportRemains",
    importInvoice = "ImportInvoice",
    gosContract = "GosContract",
    goodsClassifier = "GoodsClassifier",
    goods = "Goods",
    lots = "Lots",
    lotsByGoods = "LotsByGoods",
    cashSession = "CashSession",
    actDeduction = "ActDeduction",
    actReturnToContractor = "ActReturnToContractor",
    inventoryVed = "InventoryVed",
    inventorySved = "InventorySved",
    accessPoint = "AccessPoint",
    sysOptions = "SysOptions",
    contractor = "Contractor",
    internetOrder = "InternetOrder",
    requestForMovement = "RequestForMovement",
    kizExchange = "KizExchange",
    kizInventory = "KizInventory",
    pricingAdpriceScaleType = "PricingAdpriceScaleType",
    pricingRoundSchema = "PricingRoundSchema",
    pricingExtremeAdpriceSchemaType = "PricingExtremeAdpriceSchemaType",
    pricingMinAdpriceSchemaType = "PricingMinAdpriceSchemaType",
    pricingPriceCalcSchemaType = "PricingPriceCalcSchemaType",
    invoiceCashOrder = "InvoiceCashOrder",
    expenseCashOrder = "ExpenseCashOrder",
    marketingEvents = "MarketingEvents", // маркетинговые мероприятия
    marketingCompensatedDiscounts = "MarketingCompensatedDiscounts", // компенсируемые скидки
    taskProgram = "TaskProgram",
    actRejection = "ActRejection"
}

export enum DocumentTypeRu {
    invoice = "Приходная накладная",
    movement = "Перемещение",
    actRevaluation = "Акт переоценки",
    actDisassembling = "Акт разукомплектации",
    actDisagregation = "Акт разагрегации",
    invoiceOut = "Расходная накладная",
    invoiceCashOrder = "Приходный кассовый ордер",
    expenseCashOrder = "Расходный кассовый ордер",
    cashSession = "Кассовая смена",
    requestForMovement = "Заявка на перемещение"
}

export enum RequestState {
    Incoming = "Incoming",
    Outgoing = "Outgoing",
}

export enum DocumentState {
    new = "Новый",
    draft = "Черновик",
    cancel = "Отменён",
    proc = "Отработан",
    del = "Удален",
    done = "Завершён",
    sent = "Отправлен",
    deposited = "Отложенный",
    internetOrder = "Интернет заказ",
    Open = "Открыта",
    Closed = "Закрыта",
    mdlp = "Завершён",
    secured = "Обеспечен",
    internet_order = "Отложенный чек интернет заказа",
}

export enum DocumentStatusKizs {
    approved = "Одобрен",
    partial = "Частично одобрен",
    notApproved = "Не одобрен",
    exchange = "Выполняется обмен",
}

export enum KizState {
    Save = "Сохранен",
    Proc = "Отработан",
    Exit = "Закончен",
    Stop = "Остановлен",
    Hold = "Удержан",
    Error = "Ошибка",
    Del = "Удален",
}
export enum KizMark {
    NoKiz = "Нет КИЗ", //серый
    AllSave = "Есть КИЗ - сохранен", //синий
    AllSuccess = "Есть КИЗ - готов", //зеленый
    AllFailed = "Есть КИЗ - не готов", //красный
    PartialSuccess = "Есть КИЗ - в процессе", // желтый
    AllDisposed = "Выбыт", //зеленый
    NoneDisposed = "Не выбыт", //красный
    PartialDisposed = "Выбыт частично", // красный
    InProgressDisposal = "Идёт отправка", // желтый
    UnprocDisposal = "Не отработан"
}

export enum СhequesKizStatus {
    RED = "По одному из КИЗ не совпадают статусы",
    YELLOW = "По некоторым КИЗ статусы совпали",
    GREEN = "У всех КИЗ статусы совпали",
    GRAY = "Статусы не запрашивались",
    BLUE = "Запрос статусов отправлен",
    ORANGE = "Идет обмен"
}

export enum TypeDictionaries {
    Stop = "Приостановлена реализация",
    Allow = "Разрешено",
    Block = "Изъятие из обращения",
    error = "Ошибка",
}

export enum FieldValidation {
    Quantity = "quantity",
}

export enum defaultColumn {
    mnemocode = "Номер",
    supplierName = "Поставщик",
    storeName = "Склад",
    documentDate = "Дата",
    documentState = "Статус",
    dateModified = "Дата изменения",
    dateDeleted = "Дата удаления",
    isKizBox = "Короб",
    idStoreGlobal = "Склад",
    deleted = "Удален",
    quantityRem = "Остаток",
}

export enum SearchOption {
    kiz = "KIZ",
    name = "name",
    goodsName = "goodsName",
    kizBox = "KizBox",
    kizOrKizBox = "kizOrKizBox",
    barcode = "barcode",
    goodsCode = "goodsCode",
    goodsCodeBylot = "goodsCodeBylot",
    internalBarcode = "internalBarcode",
    kizOrKizBoxInvoice = "kizOrKizBoxInvoice",
    gtin = "gtin",
    gtinSgtin = "gtinSgtin",
    substanceName = "substanceName",
    tradeName = "tradeName",
    cureFormName = "cureFormName",
    dosage = "dosage"
}

export enum SearchOptionDocument {
    mnemocode = "mnemocode",
    supplierDocNumber = "supplierDocNumber",
}

export enum defaultOperator {
    Like = "Содержит",
    Eq = "Равно",
    NotEq = "Не равно",
    More = "Больше",
    MoreOrEq = "Больше либо равно",
    Less = "Меньше",
    LessOrEq = "Меньше либо равно",
}

export enum ViewExtension {
    dbf = 'dbf',
    sst = 'sst',
    sstProtek = 'sst.protek',
    xmlCommerceML = 'xml.commerceml'
}

export enum Extensions {
    dbf = "dbf",
    sst = "sst",
    xml = "xml"
}

export enum TypeDbf {
    string = 67,
    boolean = 76,
    numeric = 78,
    float = 70,
    dateTime = 68
}

export enum ChequePaymentType {
    Cash = "Cash",			// 1 Наличная TYPE1
    Card = "Card",			// 2 Безналичная TYPE2
    Mixed = "Mixed",		// 3 Смешанная TYPE3
    Credit = "Credit"		// 4 Кредит TYPE4
}

export const AdmissibleExtensions: IOption[] = [
    { value: "dbf", displayName: "dbf" },
    { value: "sst", displayName: "sst" },
    { value: "sst.protek", displayName: "sst-Протек" },
    { value: "xml.commerceml", displayName: "xml-CommerceML" },
];

export const GridRowHeightEnumOption = [
    { displayName: "Обычный", value: GridRowHeightEnum.normal },
    { displayName: "Разреженный", value: GridRowHeightEnum.sparse },
    { displayName: "Сжатый ", value: GridRowHeightEnum.compressed },
] as IOption[];

export const Encoding: IOption[] = [
    { value: "1251", displayName: "WIN" },
    { value: "866", displayName: "DOS" },
];

export const Delimiters: IOption[] = [
    { value: ";", displayName: ";" },
    { value: "|", displayName: "|" },
];



export enum responseErrorType {
    exception = "Исключение",
    error = "Ошибка",
    warning = "Предупреждение",
}

export enum SysOptionName {
    SmartSearch = 'SmartSearch',
    AllowUnProccesDocuments = 'AllowUnProccesDocuments',
    StateNotice = 'StateNotice',
    SaveTab = 'SaveTab',
    EsExchangeSettings = 'EsExchangeSettings',
    AllowAcquiringReturnWithDisconnectedPinpad = 'AllowAcquiringReturnWithDisconnectedPinpad',
    SourceTypeKizInventory = 'SourceTypeKizInventory',
    PrintZeroNdsOrNoNds = 'PrintZeroNdsOrNoNds',
    InvoiceIsLs = 'InvoiceIsLs',
    PermissionRegimeMdlpSetting = 'PermissionRegimeMdlpSetting',
    KizSourceForDisposalRegistrar = 'KizSourceForDisposalRegistrar',
    SettingHeightSizeOfComponents = 'SettingHeightSizeOfComponents',
    SnoEnabled = 'SnoEnabled',
    AutoSaveDocument = 'AutoSaveDocument',
    DashboardFilterSettings = "DashboardFilterSettings",
    KizValidationType = "KizValidationType",
    IndividualInventoryOfGoodsGISMT = "IndividualInventoryOfGoodsGISMT",
    ValidateInfoGismt = "ValidateInfoGismt",
    ReceivingScheduledSgtin = 'ReceivingScheduledSgtin',
    ProAptekaEnabled = 'ProAptekaEnabled',
    InternetOrderGetInfo = 'InternetOrderGetInfo',
    InventoryVedEnableAutoSendKiz = 'InventoryVedEnableAutoSendKiz',
    AllowDividedDocWriteOffWithAnyReason = 'AllowDividedDocWriteOffWithAnyReason',
    KizInvoiceOutWithoutScanPick = 'KizInvoiceOutWithoutScanPick'
}

export const FirstCountRows = 10;

export enum IdTableVariant {
    /// <summary>
    /// 2 - Приходная накладная
    /// </summary>
    Invoice = 2,

    /// <summary>
    /// 2 - Приходная накладная
    /// </summary>
    InvoiceOut = 222,

    /// <summary>
    /// 3 - Акт возврата поставщику
    /// </summary>
    ActReturnToContractor = 3,

    /// <summary>
    /// 6 - Акт разукомплектации
    /// </summary>
    ActDisassembling = 6,

    /// <summary>
    /// 7 - Кассовый чек
    /// </summary>
    Cheque = 7,

    /// <summary>
    /// 8 - Перемещение товара
    /// </summary>
    Movement = 8,

    /// <summary>
    /// 12 - Акт возврата от покупателя
    /// </summary>
    ActReturnToBuyer = 12,

    /// <summary>
    /// 13 - Акт переоценки
    /// </summary>
    ActRevaluation2 = 13,

    /// <summary>
    /// 22 - Счет
    /// </summary>
    Bill = 22,

    /// <summary>
    /// 45 - Интернет заказ
    /// </summary>
    InternetOrder = 45,

    /// <summary>
    /// 35 - Заявка на перемещение
    /// </summary>
    RequestForMovement = 35,

    /// <summary>
    /// 59 - Заказ интернет-магазина
    /// </summary>
    EShopOrder = 59,

    /// <summary>
    /// 66 - Акт разагрегации
    /// </summary>
    ActDisagregation = 66,

    /// <summary>
    /// 143 - Оперативные заявки
    /// </summary>
    RequestOperational = 143,

    /// <summary>
    /// 30 - Ввод остатков
    /// </summary>
    ImportRemains = 30,

    /// <summary>
    /// 250 - Акт списания
    /// </summary>
    ActDeduction = 250,

    /// <summary>
    /// 23 - Инвентаризационная ведомость
    /// </summary>
    InventoryVed = 23,

    /// <summary>
    /// 24 - Сводная инвентаризационная ведомость
    /// </summary>
    InventorySved = 24,

    /// <summary>
    /// 251 - Товарные остатки
    /// </summary>
    LotsByGoods = 251,

    /// <summary>
    /// 252 - Товарные остатки по партиям
    /// </summary>
    LotsByLots = 252,

    /// <summary>
    /// 260 - Киз инвентаризация
    /// </summary>
    KizInventory = 260,

    /// <summary>
    /// 491 - Приходный кассовый ордер
    /// </summary>
    InvoiceCashOrder = 491,

    /// <summary>
    /// 492 - Расходный кассовый ордер
    /// </summary>
    ExpenseCashOrder = 492,

    /// <summary>
    /// 19 - Кассовая смена
    /// </summary>
    CashSession = 19,

     /// <summary>
    /// 290 - компенсируемая скидка
    /// </summary>
    MarketingCompensatedDiscounts = 290,

     /// <summary>
    /// 290 - компенсируемая скидка
    /// </summary>
    RejectionAct = 2
}

export enum TaxType {
    /// <summary>
    /// 0 - СНО не определено
    /// </summary>
    None = 0,

    /// <summary>
    /// 1 - Основная СНО (0 / 10 / 22%)
    /// </summary>
    Basic0or10or22 = 1,

    /// <summary>
    /// 2 - Упрощенная СНО 5%
    /// </summary>
    SimplifiedRate5 = 2,

    /// <summary>
    /// 3 - Упрощенная СНО 7%
    /// </summary>
    SimplifiedRate7 = 3,

    /// <summary>
    /// 4 - Основная СНО (Переход на 22%)
    /// </summary>
    Basic20to22 = 4
}

export enum KizGoodsGroup {
    MDLP = 'MDLP',
    WTRU = 'WTRU'
}

export const TaxTypesOptions: IOption[] = [
    {
        displayName: "---",
        value: TaxType.None,
    } as IOption,
    {
        displayName: "Основная СНО (0 / 10 / 22%)",
        value: TaxType.Basic0or10or22,
    } as IOption,
    {
        displayName: "Основная СНО (Переход на 22%)",
        value: TaxType.Basic20to22,
    } as IOption,
    {
        displayName: "УСН (5%)",
        value: TaxType.SimplifiedRate5,
    } as IOption,
    {
        displayName: "УСН (7%)",
        value: TaxType.SimplifiedRate7,
    } as IOption,
];

export const TaxContractorOptions: IOption[] = [
    {
        displayName: "---",
        value: TaxType.None,
    } as IOption,
    {
        displayName: "Основная СНО",
        value: TaxType.Basic0or10or22,
    } as IOption,
    {
        displayName: "УСН (5%)",
        value: TaxType.SimplifiedRate5,
    } as IOption,
    {
        displayName: "УСН (7%)",
        value: TaxType.SimplifiedRate7,
    } as IOption,
];

export enum InvoiceDocType {
    InBw = "InBw", // 416 - обратный акцепт
    InFw = "InFw", //701 - прямой акцепт
    Moving = "Moving", //431 - перемещение между местами деятельности одного участника
    InCm = "InCm", // 701 - приемка комиссионного товара по прямому акцепту
    InLgota = "InLgota", //701 - приемка льготного товара по прямому акцепту
    InCmBw = "InCmBw", // 473 - приемка комиссионного товара по обратному акцепту
    DelEnter = "DelEnter", // 391 - возврат выданного незарегистриованному участнику
    KssBlocking = "KssBlocking" // 0 - схема не должна была отправляться, перевести КИЗы в статус "в обороте" 
}

export enum InvoiceOutDocType {
    OutFw = "OutFw", //415 (отгрузка по прямому акцепту) 
    Moving = "Moving", //431 (перемещение между местами деятельности одного участника) 
    OutUn = "OutUn", //441 (отгрузка незарегистриованному участнику) 
    OutBw = "OutBw", //701 (подтверждение отгрузки по обратному акцепту) 
    OutCmFw = "OutCmFw", //472 (отгрузка комиссионного товара по прямому акцепту) 
    OutLgotaFw = "OutLgotaFw", //471 (отгрузка льготного товара по прямому акцепту) 
    OutCmBw = "OutCmBw", //701 (подтверждение отгрузки комиссионного товара по обратному акцепту) 
    KssBlocking = "KssBlocking" //0 (запрет отправки любой схемы) только для администратора
}

export enum MovementOutDocType {
    Moving = "Moving", //431 (перемещение между местами деятельности одного участника) 
    OutUn = "OutUn", //441 (отгрузка незарегистриованному участнику) 
    MovingLgota = "MovingLgota", //470 (перемещение льготного товара между местами деятельности одного участника) 
    DelWithDrawal = "DelWithDrawal", //552 (списание без уничтожения)
    KssBlocking = "KssBlocking" //0 (запрет отправки любой схемы)
}

